import { ToggleProps } from '~/types/common.types'

export const ToggleButton = ({ value, onChange }: ToggleProps): React.ReactElement => {
  return (
    <button
      className={`relative flex items-center w-10 h-4 rounded-full p-1 transition-all duration-300 ${
        value ? 'bg-purple-focus' : 'bg-gray-light-2'
      }`}
      onClick={() => onChange(!value)}
    >
      <div
        className={`w-3 h-3 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
          value ? 'translate-x-5' : 'translate-x-0'
        }`}
      />
    </button>
  )
}
